// extracted by mini-css-extract-plugin
module.exports = {"ScriptModule_Heading":"ScriptModule_ScriptModule_Heading__7XM_8"};